import { FC } from 'react';
import { Loader } from '@servicetitan/web-components';
import { Spinner } from '@servicetitan/design-system';
import classnames from 'classnames';

import { GlobalSearchMFEErrorFallback } from './global-search-mfe-error-fallback';

const loadingFallback = <Spinner size="tiny" />;

const errorFallback = <GlobalSearchMFEErrorFallback />;

const className = classnames([
    'h-100',
    'w-100',
    'd-f',
    'justify-content-center',
    'align-items-center',
]);

interface GlobalSearchLoaderProps {
    src: string;
}

export const GlobalSearchLoader: FC<GlobalSearchLoaderProps> = ({ src }) => {
    const data = { baseUrl: window.location.origin, isEnterpriseHub: true };

    return (
        <Loader
            src={src}
            data={data}
            loadingFallback={loadingFallback}
            errorFallback={errorFallback}
            className={className}
            data-cy="global-search-mfe-loader"
            // Cache the MFE until page reload instead of 15 minutes.
            cache={-1}
        />
    );
};
